import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

const DeleteConfirmModal = ({ isOpen, onClose, potentialDriver, onConfirm }) => {
    const { isDark } = useTheme();

    if (!isOpen || !potentialDriver) return null;

    const styles = {
        overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
        },
        modal: {
            background: isDark ? '#1e1e1e' : '#ffffff',
            borderRadius: '1rem',
            padding: '2rem',
            maxWidth: '400px',
            width: '90%',
            boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.3)',
        },
        header: {
            fontSize: '1.25rem',
            fontWeight: 'bold',
            marginBottom: '1rem',
            color: isDark ? '#ffffff' : '#1f2937',
        },
        message: {
            marginBottom: '1.5rem',
            color: isDark ? '#d1d5db' : '#6b7280',
            lineHeight: 1.5,
        },
        driverName: {
            fontWeight: 600,
            color: isDark ? '#ffffff' : '#1f2937',
        },
        buttonGroup: {
            display: 'flex',
            gap: '1rem',
        },
        cancelButton: {
            flex: 1,
            padding: '0.75rem',
            background: isDark ? '#374151' : '#e5e7eb',
            color: isDark ? '#d1d5db' : '#374151',
            border: 'none',
            borderRadius: '0.5rem',
            cursor: 'pointer',
            fontWeight: 600,
            fontSize: '0.875rem',
        },
        deleteButton: {
            flex: 1,
            padding: '0.75rem',
            background: '#dc2626',
            color: 'white',
            border: 'none',
            borderRadius: '0.5rem',
            cursor: 'pointer',
            fontWeight: 600,
            fontSize: '0.875rem',
        },
    };

    return (
        <div style={styles.overlay} onClick={onClose}>
            <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
                <h2 style={styles.header}>Delete Potential Driver</h2>
                <p style={styles.message}>
                    Are you sure you want to delete{' '}
                    <span style={styles.driverName}>
                        {potentialDriver.first_name} {potentialDriver.last_name}
                    </span>
                    ? This action cannot be undone.
                </p>
                <div style={styles.buttonGroup}>
                    <button
                        onClick={onClose}
                        style={styles.cancelButton}
                    >
                        Cancel
                    </button>
                    <button
                        onClick={() => onConfirm(potentialDriver.id)}
                        style={styles.deleteButton}
                    >
                        Delete
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteConfirmModal;
